import { NeedsResourceDetailsDto } from '@act/shared/data-transfer-objects';
import { ResourceCard } from '@act/storybook';
import { mapResourceDetailsToResourceCardProps } from 'react-components/forms/cboResourceForm/mapToResourceDetails.util';
import { usePlacesAutocompleteEnabled } from 'react-components/places/usePlacesAutocompleteEnabled.hook';
import { userAppSelectors } from 'redux/slices/usersSlice.slice';
import {
  StyledHistoryEntry,
  StyledHistoryEntrySubheader,
  getHistoryEntryDateLine,
} from './HistoryDisplay';

interface ResourceDetailsHistoryProps {
  resourceDetails: NeedsResourceDetailsDto;
}

/**
 * Legacy need history row for a resource referral.
 *
 * @param props - Persisted resource details.
 * @returns Styled history entry; expandable {@link ResourceCard} when Places flag is on.
 */
const ResourceDetailsHistoryEntry = ({
  resourceDetails,
}: ResourceDetailsHistoryProps) => {
  const placesAutocompleteEnabled = usePlacesAutocompleteEnabled();
  const creatorName = userAppSelectors.useSelectUserById(
    resourceDetails?.creatorId
  )?.name;

  const dateLine = getHistoryEntryDateLine(
    resourceDetails?.createdAt,
    creatorName
  );

  return (
    <StyledHistoryEntry
      header={`Resource referred: ${resourceDetails?.resourceName}`}
      content={
        <StyledHistoryEntrySubheader>{dateLine}</StyledHistoryEntrySubheader>
      }
      expandedContent={
        placesAutocompleteEnabled ? (
          <ResourceCard
            {...mapResourceDetailsToResourceCardProps(resourceDetails)}
          />
        ) : undefined
      }
    />
  );
};

export default ResourceDetailsHistoryEntry;
